<div class="col-md-12" *ngIf="alumno">
  <mat-tab-group>
    <mat-tab label="Datos del Alumno">
      <form #f="ngForm">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-sm-6">
                <label for="nombre">Nombre</label>
                <input
                  #nombre="ngModel"
                  [(ngModel)]="alumno.nombre"
                  name="nombre"
                  type="text"
                  class="form-control"
                  id="nombre"
                  required
                  placeholder="Nombre"
                />

                <small
                  class="text-danger font-14"
                  *ngIf="nombre.touched && nombre.invalid"
                >
                  Nombre es requerido
                </small>
              </div>
              <div class="form-group col-sm-6">
                <label for="apellido">Apellido</label>
                <input
                  #apellido="ngModel"
                  [(ngModel)]="alumno.apellido"
                  name="apellido"
                  type="text"
                  class="form-control"
                  id="apellido"
                  required
                  placeholder="Apellido"
                />

                <small
                  class="text-danger font-14"
                  *ngIf="apellido.touched && apellido.invalid"
                >
                  Apellido es requerido
                </small>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6">
                <label for="direccion">Direccion</label>
                <input
                  #direccion="ngModel"
                  [(ngModel)]="alumno.direccion"
                  name="direccion"
                  type="text"
                  class="form-control"
                  id="direccion"
                  required
                  placeholder="Direccion"
                />
              </div>
              <div class="form-group col-sm-6">
                <label for="eMail">NomEMailbre</label>
                <input
                  #eMail="ngModel"
                  [(ngModel)]="alumno.eMail"
                  name="eMail"
                  type="text"
                  class="form-control"
                  id="eMail"
                  required
                  placeholder="EMail"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-3">
                <label for="dni">Documento</label>
                <input
                  #dni="ngModel"
                  [(ngModel)]="alumno.dni"
                  name="dni"
                  type="text"
                  class="form-control"
                  id="dni"
                  required
                  placeholder="Documento"
                />

                <small
                  class="text-danger font-14"
                  *ngIf="dni.touched && dni.invalid"
                >
                  Docuemento es requerido
                </small>
              </div>
              <div class="form-group col-sm-3">
                <label for="legajo">Legajo</label>
                <input
                  #legajo="ngModel"
                  [(ngModel)]="alumno.legajo"
                  name="legajo"
                  type="text"
                  class="form-control"
                  id="legajo"
                  required
                  placeholder="Legajo"
                />

                <small
                  class="text-danger font-14"
                  *ngIf="legajo.touched && legajo.invalid"
                >
                  Legajo es requerido
                </small>
              </div>
              <div class="form-group col-sm-3">
                <label for="fechaNacimiento">Fecha Nacimiento</label>
                <input
                  [ngModel]="alumno.fechaNacimiento | date : 'yyyy-MM-dd'"
                  (change)="setFechaNacimiento($event.target.value)"
                  name="fechaNacimiento"
                  type="date"
                  placeholder="Fecha Nacimiento (mes/dia/año)"
                  id="fechaNacimiento"
                  class="form-control"
                />
              </div>
              <div class="form-group col-sm-3">
                <label for="fechaIngreso">Fecha Ingreso</label>
                <input
                  [ngModel]="alumno.fechaIngreso | date : 'yyyy-MM-dd'"
                  (change)="setFechaIngreso($event.target.value)"
                  name="fechaIngreso"
                  type="date"
                  placeholder="Fecha Ingreso (mes/dia/año)"
                  id="fechaIngreso"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6">
                <!-- <label for="direccion">Direccion</label>
                                    <input
                                        #direccion="ngModel"
                                        [(ngModel)]="alumno.direccion"
                                        name="direccion"
                                        type="text"
                                        class="form-control"
                                        id="direccion"
                                        required
                                    />
                                    <div class="alert alert-danger" *ngIf="direccion.touched && direccion.invalid"> Direccion es requerido </div>  -->
              </div>
              <!-- <div class="form-group col-sm-6">
                                <label for="localidad">Localidad</label>
                            </div> -->
            </div>
            <div class="row">
              <div class="form-group col-sm-3">
                <label for="telefono1">Telefono</label>
                <input
                  #telefono1="ngModel"
                  [(ngModel)]="alumno.telefono1"
                  name="telefono1"
                  type="tel"
                  class="form-control"
                  placeholder="Telefono"
                  id="telefono1"
                  required
                />

                <small
                  class="text-danger font-14"
                  *ngIf="telefono1.touched && telefono1.invalid"
                >
                  Telefono es requerido
                </small>
              </div>
              <div class="form-group col-sm-3">
                <label for="telefono2">Telefono Alternativo</label>
                <input
                  #telefono1="ngModel"
                  [(ngModel)]="alumno.telefono2"
                  name="telefono2"
                  type="tel"
                  class="form-control"
                  placeholder="Telefono Alternativo"
                  id="telefono2"
                />
              </div>
              <div class="form-group col-sm-3">
                <label for="genero">Genero</label>
                <select
                  #geneross="ngModel"
                  [(ngModel)]="alumno.genero"
                  name="genero"
                  id="genero"
                  class="form-control"
                  required
                >
                  <option *ngFor="let c of generos.list" [value]="c.id">
                    {{ c.descripcion }}
                  </option>
                </select>
                <div
                  class="alert alert-danger"
                  *ngIf="geneross.touched && geneross.invalid"
                >
                  Genero es requerido
                </div>
              </div>

              <div class="form-group col-sm-3">
                <label for="gradoId">Grado</label>
                <select
                  #gradoIds="ngModel"
                  [(ngModel)]="gradoId"
                  name="genero"
                  id="genero"
                  class="form-control"
                  required
                >
                  <option *ngFor="let c of grados" [value]="c.id">
                    {{ c.nombre }}
                  </option>
                </select>
                <div
                  class="alert alert-danger"
                  *ngIf="gradoIds.touched && gradoIds.invalid"
                >
                  Grado es requerido
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-3">
                <label for="titularFactura">Titular Factura</label>
                <input
                  [(ngModel)]="alumno.titularFactura"
                  name="titularFactura"
                  type="text"
                  class="form-control"
                  placeholder="Titular Factura"
                  id="titularFactura"
                />
              </div>
              <div class="form-group col-sm-3">
                <label for="cuilTitular">Cuil/Cuit Titular</label>
                <input
                  [(ngModel)]="alumno.cuilTitular"
                  name="cuilTitular"
                  type="text"
                  class="form-control"
                  placeholder="Cuil/Cuit Titular"
                  id="cuilTitular"
                />
              </div>

              <div class="form-group col-sm-3">
                <label for="tipoDocumentoTitular">Tipo Documento Titular</label>
                <select
                  [(ngModel)]="alumno.tipoDocumentoTitular"
                  name="tipoDocumentoTitular"
                  id="tipoDocumentoTitular"
                  class="form-control"
                  required
                >
                  <option
                    *ngFor="let c of tiposDocumentoAfip.list"
                    [value]="c.id"
                  >
                    {{ c.descripcion }}
                  </option>
                </select>
              </div>

              <div class="form-group col-sm-3">
                <label for="condificonIvaTitular">Cond. Iva Titular</label>
                <select
                  [(ngModel)]="alumno.condificonIvaTitular"
                  name="condificonIvaTitular"
                  id="condificonIvaTitular"
                  class="form-control"
                  required
                >
                  <option *ngFor="let c of condifionesIva.list" [value]="c.id">
                    {{ c.descripcion }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6"></div>
              <div class="form-group col-sm-6"></div>
            </div>
            <div class="row pull-right">
              <button
                type="button"
                class="btn btn-primary mr-2"
                (click)="save()"
                [hidden]="alumno == null"
              >
                Guardar
              </button>
              <button
                type="button"
                class="btn btn-danger mr-2"
                *ngIf="alumno.activo"
                (click)="delete()"
                [hidden]="alumno == null"
              >
                Inactivar
              </button>
              <button
                type="button"
                class="btn btn-danger mr-2"
                *ngIf="!alumno.activo"
                (click)="activar()"
                [hidden]="alumno == null"
              >
                Activar
              </button>
              <button type="button" class="btn btn-warning" (click)="volver()">
                Volver
              </button>
            </div>
          </div>
        </div>
      </form>
    </mat-tab>
    <mat-tab label="Estado de cuenta">
      <app-cuentacorrientealumno
        [hidden]="alumno == null"
        [alumno]="alumno"
        (agregarFactura)="agregarFactura($event)"
        (actualizarAlumno)="actualizarAlumno($event)"
        [actualizarCC]="actualizarCCData"
      ></app-cuentacorrientealumno>
    </mat-tab>
    <mat-tab label="Historial de pagos">
      <app-facturasalumno
        [hidden]="alumno == null"
        [alumno]="alumno"
        [agregarFactura]="facturaNueva"
        (actualizarAlumno)="actualizarAlumno($event)"
        (anularFactura)="actualizarCC($event)"
      ></app-facturasalumno>
    </mat-tab>
  </mat-tab-group>
</div>
